import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Activity from "Navigation/Course/Content/Labs/Student/ActivityContainer/ActivityContainer"

const OtherLabsIframe = () => {
    const params = useParams();

    return (
        <Activity courseId={params.courseId} />
    );
}

export default OtherLabsIframe;

